import React from 'react';
import glamorous from 'glamorous';

import { media, font } from '../../styles';
import { propTypes, defaultProps } from './types';

const rules = {
  fontWeight: 200,
  fontSize: font.getFontSize(1.625),
  lineHeight: font.getLineHeight(1.15384615),

  [media('sm')]: {
    fontSize: font.getFontSize(2),
    lineHeight: font.getLineHeight(1.25),
  },

  [media('md')]: {
    fontSize: font.getFontSize(2.25),
    lineHeight: font.getLineHeight(1.25),
  },
};

const style = props => ({
  ...rules,
  marginTop: props.marginTop,
  marginBottom: props.marginBottom,
  textAlign: props.align,
  ...props.glamStyle,
});

const baseStyle = style({});
const H2 = glamorous.h2(baseStyle, style);

class Subtitle extends React.PureComponent {
  static propTypes = propTypes;
  static defaultProps = defaultProps;

  render() {
    const {
      children,
      style,
      ...rest,
    } = this.props;

    return (
      <H2 {...rest} glamStyle={style}>
        {children}
      </H2>
    );
  }
}

export default Subtitle;



// WEBPACK FOOTER //
// ./src/components/typography/Subtitle.js